export const test = {
  countries: [],
  countryLanguages: [],
};

export const initial = {
  countries: [],
  countryLanguages: [],
};
